import React, { useEffect, useMemo, useState } from 'react';
import { Button } from "react-bootstrap";
import { Form } from 'react-bootstrap';
import { Controller, useForm } from 'react-hook-form';
import LoadingButtonWithForm from '../../../components/LoadingButtonWithForm';
import { useParams } from 'react-router-dom';
import { convertToFormData, sweetAlert } from '../../../utils';
import { useSaveApplicationMutation } from '../../../redux/services/ApplicationService';
import { responseError } from '../../../helpers/responseHandler';

const StepOne = ({ setActiveStep, params, isEdit, setIsEdit }) => {
    let {
        control,
        register,
        handleSubmit,
        setValue,
        watch,
        reset,
        formState: { errors },
    } = useForm()

    const [editRequest, { isLoading: editLoading }] = useSaveApplicationMutation()

    const [countries, setCountries] = useState([]);
    const [states, setStates] = useState([]);
    const [cities, setCities] = useState([]);
    const [selectedCountry, setSelectedCountry] = useState('');
    const [selectedState, setSelectedState] = useState('');



    useEffect(() => {
        fetch('https://countriesnow.space/api/v0.1/countries/')
            .then((response) => response.json())
            .then((data) => {
                setCountries(data.data.map((country) => country.country));
            })
            .catch((error) => console.error('Error fetching countries:', error));
    }, []);

    const handleCountryChange = (country) => {
        setSelectedCountry(country);
        setSelectedState(''); // Reset state and city when country changes
        setCities([]);

        fetch(`https://countriesnow.space/api/v0.1/countries/states/q?country=${country}`)
            .then((response) => response.json())
            .then((data) => {
                setStates(data?.data?.states || []);
            })
            .catch((error) => console.error('Error fetching states:', error));
    };

    const handleStateChange = (state) => {
        setSelectedState(state);

        fetch(`https://countriesnow.space/api/v0.1/countries/state/cities/q?country=${selectedCountry || isEdit?.country}&state=${state}`)
            .then((response) => response.json())
            .then((data) => {
                setCities(data?.data || []);
            })
            .catch((error) => console.error('Error fetching cities:', error));
    };


    const country = useMemo(() => isEdit?.country, [])
    const statess = useMemo(() => isEdit?.state, [])

    useEffect(() => {
        if (country) {
            handleCountryChange(country)
        }
    }, [country])

    useEffect(() => {
        if (statess) {
            console.log('dwe', statess)
            handleStateChange(statess)
        }
    }, [statess])


    const onSubmit = async (data) => {
        const newForm = { step_no: '1', ...data }
        setIsEdit(prev => { return { ...prev, ...newForm } })
        await editRequest({ params, newForm }).unwrap()
            .then((res) => {
                setActiveStep(1)
                if (res?.status) {
                    sweetAlert(res?.message, 'success')
                }
                // if (res?.errors) {
                //     Object.entries(res?.errors)?.forEach(([key, value]) => {
                //         sweetAlert(value[0], 'error')
                //     })
                // }
            })
            .catch((err) => {
                responseError(err)
            })
    }

    return (
        <>
            {console.log('isEdit', isEdit)}
            <div className="row justify-content-center">
                <div className="col-md-9">
                    <div className="card custom-card">
                        <div className="card-body">
                            <h5 className="text-center">Personal Information</h5>
                            <div className="row">
                                <Form onSubmit={handleSubmit(onSubmit)} className="col-md-12" id='application-status'>

                                    <div className="row">
                                        <div className="col-lg-6">
                                            <Form.Group className="mb-3">
                                                <Form.Label>Full Name:</Form.Label>
                                                <Controller
                                                    name="full_name"
                                                    control={control}
                                                    defaultValue={isEdit?.full_name || ''}
                                                    rules={{
                                                        required: true
                                                    }}
                                                    render={({ field }) => (
                                                        <Form.Control
                                                            {...field}
                                                            type="text" placeholder="Enter Full Name"
                                                            isInvalid={errors.full_name}
                                                        />
                                                    )}
                                                />
                                            </Form.Group>
                                        </div>
                                        <div className="col-lg-6">
                                            <Form.Group className="mb-3">
                                                <Form.Label>Date of Birth:</Form.Label>
                                                <Controller
                                                    name="dob"
                                                    control={control}
                                                    defaultValue={isEdit?.dob || ''}
                                                    rules={{
                                                        required: true
                                                    }}
                                                    render={({ field }) => (
                                                        <Form.Control
                                                            {...field}
                                                            type="date" placeholder="Enter Date of Birth"
                                                            isInvalid={errors.dob}
                                                        />
                                                    )}
                                                />
                                            </Form.Group>
                                        </div>
                                        <div className="col-lg-6">
                                            <Form.Group className="mb-3">
                                                <Form.Label>Country:</Form.Label>
                                                <Controller
                                                    name="country"
                                                    control={control}
                                                    defaultValue={isEdit?.country || ''}
                                                    rules={{
                                                        required: false
                                                    }}
                                                    render={({ field }) => (
                                                        <Form.Control
                                                            {...field}
                                                            className='form-select'
                                                            as="select"
                                                            name="country"
                                                            value={field.value}
                                                            onChange={(e) => {
                                                                field.onChange(e)
                                                                handleCountryChange(e.target.value)
                                                            }}
                                                        >
                                                            <option value="">Select Country</option>
                                                            {countries.map((country, index) => (
                                                                <option key={index} value={country}>{country}</option>
                                                            ))}
                                                        </Form.Control>
                                                    )}
                                                />
                                            </Form.Group>
                                        </div>
                                        <div className="col-lg-6">
                                            <Form.Group className="mb-3">
                                                <Form.Label>State:</Form.Label>
                                                <Controller
                                                    name="state"
                                                    control={control}
                                                    defaultValue={isEdit?.state || ''}
                                                    rules={{
                                                        required: false
                                                    }}
                                                    render={({ field }) => (
                                                        <Form.Control
                                                            {...field}
                                                            className='form-select'
                                                            as="select"
                                                            name="state"
                                                            value={field.value}
                                                            onChange={(e) => {
                                                                field.onChange(e)
                                                                handleStateChange(e.target.value)
                                                            }}
                                                        >
                                                            <option value="">Select State</option>
                                                            {states.map((state, index) => (
                                                                <option key={index} value={state.name}>{state.name}</option>
                                                            ))}
                                                        </Form.Control>
                                                    )}
                                                />
                                            </Form.Group>
                                        </div>
                                        <div className="col-lg-6">
                                            <Form.Group className="mb-3">
                                                <Form.Label>City:</Form.Label>
                                                <Controller
                                                    name="city"
                                                    control={control}
                                                    defaultValue={isEdit?.city || ''}
                                                    rules={{
                                                        required: false
                                                    }}
                                                    render={({ field }) => (
                                                        <Form.Control
                                                            {...field}
                                                            className='form-select'
                                                            as="select"
                                                            name="city"
                                                        >
                                                            <option value="">Select City</option>
                                                            {cities.map((city, index) => (
                                                                <option key={index} value={city}>{city}</option>
                                                            ))}
                                                        </Form.Control>
                                                    )}
                                                />
                                            </Form.Group>
                                        </div>


                                        <div className="col-lg-6">
                                            <Form.Group className="mb-3">
                                                <Form.Label>Zip Code:</Form.Label>
                                                <Controller
                                                    name="zip_code"
                                                    control={control}
                                                    defaultValue={isEdit?.zip_code || ''}
                                                    rules={{
                                                        required: false
                                                    }}
                                                    render={({ field }) => (
                                                        <Form.Control
                                                            {...field}
                                                            type="text" placeholder="Enter Phone Number"
                                                            isInvalid={errors.zip_code}
                                                        />
                                                    )}
                                                />
                                            </Form.Group>
                                        </div>
                                        <div className="col-lg-12">
                                            <Form.Group className="mb-3">
                                                <Form.Label>Home Address:</Form.Label>
                                                <Controller
                                                    name="address_1"
                                                    control={control}
                                                    defaultValue={isEdit?.address_1 || ''}
                                                    rules={{
                                                        required: true
                                                    }}
                                                    render={({ field }) => (
                                                        <Form.Control
                                                            {...field}
                                                            as="textarea" rows={3} placeholder="Enter Home Address"
                                                            isInvalid={errors.address_1}
                                                        />
                                                    )}
                                                />
                                            </Form.Group>
                                        </div>
                                    </div>

                                </Form>

                                <div className="col-lg-3 d-flex mb-3">
                                    {/* <Button
                                        variant="primary"
                                        className="text-white mt-auto w-100"
                                        onClick={() => setActiveStep(1)}
                                    >
                                        Next
                                    </Button> */}
                                    <LoadingButtonWithForm
                                        isLoading={editLoading}
                                        name="Next & Save"
                                        form="application-status"
                                        className="w-100"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default StepOne;
